<template>
    <div class='spaceCenter common common-form-inline'>
        <a-form-model
        ref="ruleForm"
        :model="pageData"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        :rules="rules"
        >
            <a-form-model-item label="账户名称" prop="cstNm">
                {{userObj.cstNm}}
            </a-form-model-item>
            <a-form-model-item label="付款账号" prop="accNo">
                {{userObj.accNo}}
            </a-form-model-item>
            <a-form-model-item label="收款账号" prop="recvAccNo">
                <a-select
                    v-model="pageData.recvAccNo"
                    @change="handleChange"
                >
                    <a-select-option v-for="item in recvAccNoList" :value="item.accNo" :key="item.accNo">
                    {{item.accNo}}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="开户银行" prop="recvBankNm">
                {{pageData.recvBankNm||'（请选择收款账号）'}}
            </a-form-model-item>
            <a-form-model-item label="提现金额" prop="amount" style="white-space: nowrap;">
                <a-input v-model="pageData.amount" @keyup="pageData.amount=utils.clearNoNum(pageData.amount,false,true)"/>
                <span> 可提现金额：{{userObj.accBal}} 元</span>
            </a-form-model-item>
            <div v-if="timeFlag" class="text-color-red-1" style="text-align:center;margin-top:24px;margin-left: 62px;">
              注：工作日17:00-21:00最大提现金额100万元，其余时间不限制提现金额，请各位供应商合理安排好提现时间，如有问题请联系业务部门相关人员，谢谢合作！
            </div>
        </a-form-model>
    </div>
</template>

<script>
import {bindingAccountSelector} from "@/api/customer.js"
import {getBusinessDay,checkWithdrawInfo} from "@/api/withdraw.js"
import {mapGetters} from "vuex"
export default {
    name:"applay",
    data() {
        return {
            pageData:{
                recvAccNo:undefined,
                recvBankNm:undefined,
                amount:undefined
            },
            recvAccNoList:[],
            rules:{
                recvAccNo:{
                    required: true,
                    trigger: "blur",
                    whitespace:true,
                    message:"请填写收款账号"
                },
                amount:{
                    required: true,
                    trigger: "blur",
                    whitespace:true,
                    validator: (rule, value, cbfn) => {
                        if (!value) {
                            cbfn('请填写提现金额');
                        }
                        else if(+value > this.userObj.accBal){
                            cbfn('提现金额超出可提现额度');
                        }
                        else if(+value < 0.01){
                            cbfn('提现金额不能小于0.01元');
                        }
                        cbfn();

                    }
                }
            },
            timeFlag:false
        };
    },
    computed: {
        ...mapGetters({
            userObj: "home/getUserObj",
        })
    },
    methods: {
        getSystemTime(){
            getBusinessDay().then(res => {
                this.timeFlag = res.description && parseFloat(res.description.substr(11, 2)) >= 15;
            }).catch(err => {
                this.timeFlag = false;
            })
        },
        bindingAccountSelector(){
            bindingAccountSelector({
                cstId:this.userObj.cstId
            }).then(res => {
                this.recvAccNoList = res.data.grid.list;
            })
        },
        handleChange(data){
            let item = this.recvAccNoList.find(i => i.accNo == data);
            if(item){
                this.pageData.recvTgfi = item.largeBankNo
                this.pageData.recvBankNm = item.accBlngBnk;
            }else{
                this.pageData.recvTgfi = undefined
                this.pageData.recvBankNm = undefined;
            }
        },
        check(){
            return new Promise((resolve,reject) => {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        const params = {
                            recvAccNm: this.userObj.cstNm,
                            recvAccNo: this.pageData.recvAccNo,
                            recvBankNm: this.pageData.recvBankNm,
                            recvTgfi:this.pageData.recvTgfi,
                            amount: this.pageData.amount
                        };
                        checkWithdrawInfo(params,true).then(res => {
                            resolve(params);
                        }).catch(err => {
                            this.errMsg = err.description;
                            reject(err);
                        })

                    } else {
                        return false;
                    }
                });
            })
        }
    },
    created() {
        this.bindingAccountSelector();
        this.getSystemTime();
    },
    mounted() {},
    watch: {}
}
</script>
<style scoped>
.common-form-inline{
    margin: 40px 0;
}
.input-box{
    position: relative;
}
.input-btn{
    position: absolute;
    right: 5px;
    top: 8px;
    font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/withdraw/applay.vue